import axios from "axios";
import { Principal } from "../types/principal";

export const findSite = async (dataURL: string): Promise<Principal> => {
  const response = await axios.get(dataURL);
  // const response = await api.get(`/sites-prd/sites`, {
  //     params,
  // });
  return response.data;
};
